// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__bRyTZ","buttons":"RemoveExpirationActionButtons_buttons__Vh-vV"};